module.exports = __webpack_public_path__ + "img/company_4.53b8bb0c.png";